<template>
  <div class="sticky-btn-wrap">
    <btn class="sticky-btn" v-bind="$attrs" v-on="$listeners">
      <slot/>
    </btn>
  </div>
</template>

<script>
  import Btn from './Btn.vue'

  export default {
    inheritAttrs: false,
    name: 'StickyBtn',
    components: {
      Btn,
    }
  }
</script>

<style scoped lang="stylus">
  .sticky-btn-wrap
    @media (max-width: 510px)
      margin-left -15px
      margin-right -15px

  .sticky-btn
    width 100%

    @media (max-width: 510px)
      border-radius 0
</style>
